export const STATUS_OK = 0;
export const STATUS_ERROR = -1;
export const STATUS_LEAVEREQUESTTIED = -2;
export const STATUS_ALREADYAPPROVED = -3;